import React from 'react';
import PropTypes from 'prop-types';
import Button from '@adsk/bim360-matrix-react-button';
import ModalConfirmation from '@adsk/bim360-matrix-react-modal-confirmation';
import i18n from '../../../utils/i18n';

const IssueTypesAdminChangeActiveStatusModal = ({isOpen, onConfirm, onModalClose, container}) => {
  const modalMessage = (
    <div className="IssueTypesAdminChangeStatusModal">
      <p className="IssueTypesAdminChangeStatusModal__text">{i18n.t('issueTypes.modal.disableIssueType')}</p>
      <p className="IssueTypesAdminChangeStatusModal__text">{i18n.t('issueTypes.modal.disableIssueTypeConfirm')}</p>
    </div>
  );

  return (
    <ModalConfirmation
      show={isOpen}
      onConfirm={onConfirm}
      title={i18n.t('issueTypes.modal.changeStatusTitle')}
      message={modalMessage}
      onHide={onModalClose}
      onExited={onModalClose}
      container={container}
      hideOnConfirm
      confirmationButtonLabel={i18n.t('issueTypes.modal.change')}
      confirmationButtonStyleType={Button.StyleType.PRIMARY}
      cancelButtonLabel={i18n.t('issueTypes.modal.cancel')}
    />
  );
};

IssueTypesAdminChangeActiveStatusModal.displayName = 'IssueTypesAdminChangeStatusModal';

IssueTypesAdminChangeActiveStatusModal.propTypes = {
  container: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onModalClose: PropTypes.func
};
export default IssueTypesAdminChangeActiveStatusModal;
